// extracted by mini-css-extract-plugin
export default {"container":"ProjectsCategories_container__Uldv9","title":"ProjectsCategories_title__yQxiz","cardsContainer":"ProjectsCategories_cardsContainer__Y1Gmp"};